export enum EntitySelectionType {
  Checkbox,
  Combobox,
  Radio,
  Dropdown,
}
